module.exports = __webpack_public_path__ + "static/media/dumbellActive.e7676c7e.svg";